import { State, StateContext } from '../base/state';
import { stateTypes } from '../constants';

export class Context extends StateContext {
  constructor(controller) {
    super({
      controller,
      InitialInstance: InitialState,
      eventType: stateTypes.selectedOwner,
    });
    this.selectOwner = this.selectOwner.bind(this);
  }

  selectOwner(value) {
    if (!value) {
      this.reset();
      return;
    }

    this.transitionTo(new SuccessState(value));
  }
}

export class InitialState extends State {
  constructor() {
    super({ status: 'idle' });
  }
}

export class LoadingState extends State {
  constructor() {
    super({ status: 'loading' });
  }
}

export class ErrorState extends State {
  constructor() {
    super({
      status: 'error',
      message:
        'Не удалось получить записанного собственника. Попробуйте еще раз',
    });
  }
}

export class SuccessState extends State {
  constructor(value) {
    super({ status: 'success', value });
  }
}
